<template>
	<span class="graph" :class="`${type}`">
		<span class="lines" v-if="showLines"><span></span><span></span><span></span></span>
		<span class="bar-wrapper">
			<span class="bar" :style="barStyleObject" :title="barTitle"></span>
		</span>
		<span class="dot" :class="dotClassObject" :style="dotStyleObject" :title="dotTitle"></span>
	</span>
</template>

<script>
export default {
	name: 'ArticleAnalysis',
	props: {
		showLines: {
			type: Boolean,
			default: false
		},
		data: {
			type: Object
		},
		typeOverride: {
			type: String
    },
    mode: String
	},
	computed: {
		type() {
			if(this.typeOverride) {
				return this.typeOverride
			} else {
				if(this.showLines) {
					return 'large'
				} else {
					return 'small'
				}
			}
    },
    isArticle() {
      // Sketch legacy stuff
      return (this.type == 'small' || this.type == 'tiny' || this.type == 'storytiny');
    },
		dotStyleObject() {
			if(this.isArticle) {
				return {
					left: `${this.data.score}%`,
				};
			} else {
				return {
					left: `${this.data.scores.xo}%`,
				};
			}
		},
		dotClassObject() {
			if(this.isArticle) {
				return `${this.data.group.code}`;
			} else {
				return `${this.data.scores.group.code}`;
			}
    },
    dotClass(){
      if(this.isArticle) {
				return this.data.group;
			} else {
				return this.data.scores.group;
			}
    },
		barStyleObject() {
			if(this.data.boundaries) {
				return {
					left: `${this.data.boundaries.dispersion.min}%`,
					width: `${this.data.boundaries.dispersion.max - this.data.boundaries.dispersion.min}%`
				};
			} else {
				return false;
			}
    },
    dotTitle() {
      let label = this.dotClass.name.toLowerCase();
      if (this.mode == 'topic'){
        return this.isArticle ? 
          `This is our assessment of how ${label} this article is` : 
          `Your reading of this subject has been ${label}.`;
      } else {
        return `Your reading of this publisher has been ${label}.`;
      }
    },
    barTitle() {
      return `At the moment, general sentiment on this subject is in this range.`;
    },
	}
};
</script>

<style lang="scss" scoped>
	@import '~styles/_variables';

	.graph {
		@include palette-block;
		// margin-left: 1em;
		flex: 5;
		border-radius: 50px;
		height: 23px;
		position: relative;
		display: block;
		&::before {
			// @include palette-block;
			position: absolute;
			content: "";
			top: 0;
			bottom: 0;
			width: 20px;
			left: -10px;
		}
	}

	.bar-wrapper,
	.bar,
	.dot {
		display: block;
		position: absolute;
		top: 9px;
    cursor: pointer;
	}

	.bar-wrapper {
		margin: 0 4px;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}

	.bar {
		height: 5px;
		background: rgba(255, 255, 255, 0.1);
		border-radius: 50px;
    cursor: pointer;
	}

	.lines {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		display: flex;
		justify-content: space-between;
		padding: 0 1em;
		span {
			width: 1px;
			height: 100%;
			background: rgba(16, 24, 24, 0.15);
		}
	}

	.dot {
		top: 6px;
		height: 11px;
		width: 11px;
		left: 20%;
		border-radius: 50px;
		&.negative,
		&.very-negative {
			background: rgb(244, 93, 2);
		}
		&.neutral {
			background: rgb(45, 125, 210);
		}
		&.positive,
		&.very-positive {
			background: rgb(126, 198, 34);
		}
	}

	.small {
		height: 28px;
		margin-right: 0.5em !important;
		.bar-wrapper {
			margin: 0 18px;
		}
		.bar,
		.dot {
			top: 5px;
			height: 18px;
		}
		.dot {
			width: 18px;
		}
	}


	.small,
	.tiny,
	.storytiny {
		&.graph::before {
			// @include palette-block;
			display: none;
		}
	}


	.tiny {
		max-width: 500px;
		height: 23px;
		position: relative;
		&::after {
			position: absolute;
			content: "";
			display: block;
			top: 0;
			bottom: 0;
			width: 20px;
			left: -10px;
			@include palette-block;
		}
		.bar,
		.dot {
			top: 4px;
			height: 15px;
			z-index: 20;
		}
		.dot {
			width: 15px;
		}
	}

	.tiny,
	.storytiny {
		max-width: 500px;
		height: 10px;
		position: relative;
		.bar{
			top: 1px;
			width: 8px;
			height: 8px;
			z-index: 20;
		}
		.dot {
			top: 2px;
			width: 6px;
			height: 6px;
			z-index: 20;
		}
	}

</style>